
import { NavLink } from "react-router-dom";

interface NavItemsProps {
  isAuthenticated: boolean;
  userRole: string | null | undefined;
  className?: string;
  onItemClick?: () => void;
}

export function NavItems({ 
  isAuthenticated, 
  userRole, 
  className,
  onItemClick
}: NavItemsProps) {
  return (
    <nav className={className}>
      <NavLink to="/" className="text-sm font-medium" onClick={onItemClick}>
        Home
      </NavLink>
      <NavLink to="/compro-oro" className="text-sm font-medium" onClick={onItemClick}>
        Compro Oro
      </NavLink>
      <NavLink to="/grafici" className="text-sm font-medium" onClick={onItemClick}>
        Grafici
      </NavLink>
      <NavLink to="/avvisi" className="text-sm font-medium" onClick={onItemClick}>
        Avvisi
      </NavLink>
      <NavLink to="/gildy" className="text-sm font-medium" onClick={onItemClick}>
        Gildy
      </NavLink>
      <NavLink to="/previsioni" className="text-sm font-medium" onClick={onItemClick}>
        Previsioni AI
      </NavLink>
      <NavLink to="/blog" className="text-sm font-medium" onClick={onItemClick}>
        Blog
      </NavLink>
      {isAuthenticated && (
        <NavLink to="/profilo" className="text-sm font-medium" onClick={onItemClick}>
          Profilo
        </NavLink>
      )}
      {isAuthenticated && (userRole === 'admin' || userRole === 'super_admin') && (
        <NavLink to="/admin" className="text-sm font-medium" onClick={onItemClick}>
          Admin
        </NavLink>
      )}
    </nav>
  );
}
